import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import { useNavigate } from "react-router";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import LoadingPage from "../../../Components/layouts/loading";
import { RiContactsBookLine } from "react-icons/ri";
import { FcSurvey } from "react-icons/fc";
import StepRoutes from "../../../Routes/steps_routes";

const FinancialDashboard = () => {
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [recurringToggle, setRecurringTogle] = useState(false);
  const [fixedToggle, setFixedToggle] = useState(false);
  const [marketingToggle, setMarketingToggle] = useState(false);
  const [recurringMonthlyToggle, setRecurringMonthlyToggle] = useState(false);
  const [fixedMonthlyToggle, setFixedMonthlyToggle] = useState(false);
  const [marketingMonthlyToggle, setMarketingMonthlyToggle] = useState(false);
  const [marketingYearlyToggle, setMarketingYearlyToggle] = useState(false);
  const [recurringYearlyToggle, setRecurringYearlyToggle] = useState(false);
  const [fixedYearlyToggle, setFixedYearlyToggle] = useState(false);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    paymentStatus: "",
    webinarId: "",
  });
  const [dailyAndMonthlyIncome, setDailyAndMonthlyIncome] = useState();
  const [dailyExpense, setDailyExpense] = useState();
  const [weeklyExpense, setWeeklyExpense] = useState();
  const [monthlyExpense, setMonthlyExpense] = useState();
  const [yearlyExpense, setYearlyExpense] = useState();
  const [dailyProfit, setDailyProfit] = useState();
  const [monthlyProfit, setMonthlyProfit] = useState();
  const [yearlyProfit, setYearlyProfit] = useState();
  const [fixedWeeklyToggle, setFixedWeeklyToggle] = useState();
  const [recurringWeeklyToggle, setRecurringWeeklyToggle] = useState();
  const [marketingWeeklyToggle, setMarketingWeeklyToggle] = useState();
  const [loading, setLoading] = useState(false);
  const [weeklyProfit, setWeeklyProfit] = useState();

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-daily-and-monthly-income/`, page, filters)
    )
      .then((res) => {
        if (res?.data) {
          setDailyAndMonthlyIncome(res?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-daily-expense/`, page, filters)
    )
      .then((res) => {
        setDailyExpense(res?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-weekly-expense/`, page, filters)
    )
      .then((res) => {
        setWeeklyExpense(res?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-monthly-expense/`, page, filters)
    )
      .then((res) => {
        setMonthlyExpense(res?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);
  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-yearly-expense/`, page, filters)
    )
      .then((res) => {
        setYearlyExpense(res?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  const handleDropdown = (data) => {
    if (data === "recurring") {
      setRecurringTogle(!recurringToggle);
      return;
    } else if (data === "fixed") {
      setFixedToggle(!fixedToggle);
      return;
    } else if (data === "marketing") {
      setMarketingToggle(!marketingToggle);
      return;
    } else if (data === "fixedWeekly") {
      setFixedWeeklyToggle(!fixedWeeklyToggle);
      return;
    } else if (data === "recurringWeekly") {
      setRecurringWeeklyToggle(!recurringWeeklyToggle);
      return;
    } else if (data === "marketingWeekly") {
      setMarketingWeeklyToggle(!marketingWeeklyToggle);
      return;
    } else if (data === "recurringMonthly") {
      setRecurringMonthlyToggle(!recurringMonthlyToggle);
      return;
    } else if (data === "fixedMonthly") {
      setFixedMonthlyToggle(!fixedMonthlyToggle);
      return;
    } else if (data === "marketingMonthly") {
      setMarketingMonthlyToggle(!marketingMonthlyToggle);
      return;
    } else if (data === "marketingYearly") {
      setMarketingYearlyToggle(!marketingYearlyToggle);
      return;
    } else if (data === "recurringYearly") {
      setRecurringYearlyToggle(!recurringYearlyToggle);
      return;
    } else if (data === "fixedYearly") {
      setFixedYearlyToggle(!fixedYearlyToggle);
      return;
    }
    setRecurringYearlyToggle(false);
    setFixedYearlyToggle(false);
    setMarketingYearlyToggle(false);
    setFixedYearlyToggle(false);
    setRecurringTogle(false);
    setFixedToggle(false);
    setFixedWeeklyToggle(false);
    setMarketingToggle(false);
    setRecurringWeeklyToggle(false);
    setMarketingWeeklyToggle(false);
  };

  useEffect(() => {
    if (dailyAndMonthlyIncome) {
      const dIncome = parseFloat(dailyAndMonthlyIncome.dailyIncome || 0);
      const dIncentive = parseFloat(
        dailyAndMonthlyIncome.dailyIncentivePaids || 0
      );
      const wIncome = parseFloat(dailyAndMonthlyIncome.weeklyIncome || 0);
      const wIncentive = parseFloat(
        dailyAndMonthlyIncome.weeklyIncentivePaid || 0
      );
      const mIncome = parseFloat(dailyAndMonthlyIncome.monthlyIncome || 0);
      const mIncentive = parseFloat(
        dailyAndMonthlyIncome.monthlyIncentivePaids || 0
      );

      const yIncome = parseFloat(dailyAndMonthlyIncome.yearlyIncome || 0);
      const yIncentive = parseFloat(
        dailyAndMonthlyIncome.yearlyIncentivePaid || 0
      );

      // Daily Profit
      if (dailyExpense) {
        const dExpense =
          parseFloat(dailyExpense.getDailyTotalExpense || 0) + dIncentive;
        let dProfit = dIncome - dExpense;
        setDailyProfit(dProfit.toFixed(2));
      }

      // Weekly Profit
      if (weeklyExpense) {
        const wExpense =
          parseFloat(weeklyExpense.getWeeklyTotalExpense || 0) + wIncentive;
        let wProfit = wIncome - wExpense;
        setWeeklyProfit(wProfit.toFixed(2));
      }

      // Monthly Profit
      if (monthlyExpense) {
        const mExpense =
          parseFloat(monthlyExpense.getMonthlyTotalExpense || 0) + mIncentive;
        let mProfit = mIncome - mExpense;
        setMonthlyProfit(mProfit.toFixed(2));
      }

      // Yearly Profit
      if (yearlyExpense) {
        const yExpense =
          parseFloat(yearlyExpense.getYearlyTotalExpense || 0) + yIncentive;
        let yProfit = yIncome - yExpense;
        setYearlyProfit(yProfit);
      }
    }
  }, [
    dailyExpense,
    weeklyExpense,
    monthlyExpense,
    yearlyExpense,
    dailyAndMonthlyIncome,
  ]);

  const handleNavigate = () => {
    navigate("/add-financial-expense");
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="col-12 mb-4 d-flex">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2 me-1" /> Expense Tracking
                </h2>
                <h4 className="text-muted">
                  {/* Company Financial Dashboard   */}
                  <StepRoutes />
                </h4>
              </div>
              <div className="">
                <button
                  className="btn btn-primary"
                  onClick={() => navigate("/view-financial-expense")}
                >
                  View Expenditure
                </button>
                <button
                  className="btn btn-primary ms-2"
                  onClick={() => handleNavigate()}
                >
                  Add Expenditure
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      name: "",
                                      paymentStatus: "",
                                      webinarId: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    name: "",
                                    paymentStatus: "",
                                    webinarId: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 border  border-black  rounded p-4 mt-2">
              <h2 className="text-center mb-4">Financial Summary</h2>

              <div className="row d-flex">
                {/* Daily Expenses */}
                <div className="mb-4 col">
                  <div className="d-flex justify-content-between py-1">
                    <h4 className="pb-2">Daily Expenses</h4>

                    <strong>{dailyExpense?.todayDate}</strong>
                  </div>

                  <div className="d-flex justify-content-between border-bottom py-1">
                    <span>Total</span>

                    <strong>₹ {dailyExpense?.getDailyTotalExpense}</strong>
                  </div>

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("recurring")}>
                      {recurringToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Recurring
                    </span>
                    <span>₹ {dailyExpense?.getDailyRecurringExpense}</span>
                  </div>
                  {recurringToggle && (
                    <>
                      {dailyExpense?.getRecurringExpensesPerDay &&
                        Object.entries(
                          dailyExpense?.getRecurringExpensesPerDay.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("fixed")}>
                      {fixedToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Fixed
                    </span>
                    <span>₹ {dailyExpense?.getDailyFixedExpense}</span>
                  </div>
                  {fixedToggle && (
                    <>
                      {dailyExpense?.getFixedExpensesPerDay &&
                        Object.entries(
                          dailyExpense?.getFixedExpensesPerDay?.reduce(
                            (acc, curr) => {
                              const category = curr?.category;
                              const amount = parseFloat(curr?.amount || 0);

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            {category ?? <span>{category}</span>}
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("marketing")}>
                      {marketingToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Marketing
                    </span>
                    <span>₹ {dailyExpense?.getDailyMarketingExpense}</span>
                  </div>
                  {marketingToggle && (
                    <>
                      {dailyExpense?.getMarketingExpensesPerDay &&
                        Object.entries(
                          dailyExpense?.getMarketingExpensesPerDay?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip items with no category

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}
                </div>
                {/* Weekly Expenses */}
                <div className="mb-4 col ">
                  <div className="d-flex justify-content-between py-1">
                    <h4 className="pb-2">Weekly Expenses</h4>

                    <strong>
                      Week - {weeklyExpense?.currentWeekNumberInMonth}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between border-bottom py-1">
                    <span>Total</span>

                    <strong>₹ {weeklyExpense?.getWeeklyTotalExpense}</strong>
                  </div>

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("recurringWeekly")}>
                      {recurringWeeklyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Recurring
                    </span>
                    <span>₹ {weeklyExpense?.totalWeeklyRecurringExpense}</span>
                  </div>
                  {recurringWeeklyToggle && (
                    <>
                      {weeklyExpense?.getReccuringWeeklyExpense &&
                        Object.entries(
                          weeklyExpense?.getReccuringWeeklyExpense?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip if category is missing

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("fixedWeekly")}>
                      {fixedWeeklyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Fixed
                    </span>
                    <span>₹ {weeklyExpense?.totalWeeklyFixedExpense}</span>
                  </div>
                  {fixedWeeklyToggle && (
                    <>
                      {weeklyExpense?.getFixedWeeklyExpense &&
                        Object.entries(
                          weeklyExpense?.getFixedWeeklyExpense?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip missing categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("marketingWeekly")}>
                      {marketingWeeklyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Marketing
                    </span>
                    <span>₹ {weeklyExpense?.totalWeeklyMarketingExpense}</span>
                  </div>
                  {marketingWeeklyToggle && (
                    <>
                      {weeklyExpense?.getMarketingWeeklyExpense &&
                        Object.entries(
                          weeklyExpense?.getMarketingWeeklyExpense?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // Skip invalid categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </div>
              <hr />
              <div className="row d-flex">
                <div className="mb-4 col ">
                  <div className="d-flex justify-content-between py-1">
                    <h4 className="pb-2">Monthly Expenses</h4>

                    <strong>{monthlyExpense?.monthName}</strong>
                  </div>
                  <div className="d-flex justify-content-between border-bottom py-1">
                    <span>Total</span>

                    <strong>₹ {monthlyExpense?.getMonthlyTotalExpense}</strong>
                  </div>

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("recurringMonthly")}>
                      {recurringMonthlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Recurring
                    </span>
                    <span>₹ {monthlyExpense?.getMonthlyRecurringExpense}</span>
                  </div>
                  {recurringMonthlyToggle && (
                    <>
                      {monthlyExpense?.getRecurringExpenses &&
                        Object.entries(
                          monthlyExpense?.getRecurringExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip if category is missing

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("fixedMonthly")}>
                      {fixedMonthlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Fixed
                    </span>
                    <span>₹ {monthlyExpense?.getMonthlyFixedExpense}</span>
                  </div>
                  {fixedMonthlyToggle && (
                    <>
                      {monthlyExpense?.getFixedExpenses &&
                        Object.entries(
                          monthlyExpense?.getFixedExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip missing categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("marketingMonthly")}>
                      {marketingMonthlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Marketing
                    </span>
                    <span>₹ {monthlyExpense?.getMonthlyMarketingExpense}</span>
                  </div>
                  {marketingMonthlyToggle && (
                    <>
                      {monthlyExpense?.getMarketingExpenses &&
                        Object.entries(
                          monthlyExpense?.getMarketingExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // Skip invalid categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}
                </div>

                <div className="mb-4 col">
                  <div className="d-flex justify-content-between py-1">
                    <h4 className="pb-2">Yearly Expenses(Till Now)</h4>

                    <strong>{yearlyExpense?.year}</strong>
                  </div>
                  <div className="d-flex justify-content-between border-bottom py-1">
                    <span>Total</span>

                    <strong>₹ {yearlyExpense?.getYearlyTotalExpense}</strong>
                  </div>

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("recurringYearly")}>
                      {recurringYearlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Recurring
                    </span>
                    <span>₹ {yearlyExpense?.totalYearlRecurringExpense}</span>
                  </div>
                  {recurringYearlyToggle && (
                    <>
                      {yearlyExpense?.getRecurringExpenses &&
                        Object.entries(
                          yearlyExpense?.getRecurringExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip if category is missing

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("fixedYearly")}>
                      {fixedYearlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Fixed
                    </span>
                    <span>₹ {yearlyExpense?.totalYearlyFixedExpense}</span>
                  </div>
                  {fixedYearlyToggle && (
                    <>
                      {yearlyExpense?.getFixedExpenses &&
                        Object.entries(
                          yearlyExpense?.getFixedExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // skip missing categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}

                  <div className="d-flex justify-content-between py-1">
                    <span onClick={() => handleDropdown("marketingYearly")}>
                      {marketingYearlyToggle ? (
                        <FaChevronDown size={10} />
                      ) : (
                        <FaChevronRight size={10} />
                      )}{" "}
                      Marketing
                    </span>
                    <span>₹ {yearlyExpense?.totalYearlyMarketingExpense}</span>
                  </div>
                  {marketingYearlyToggle && (
                    <>
                      {yearlyExpense?.getMarketingExpenses &&
                        Object.entries(
                          yearlyExpense?.getMarketingExpenses?.reduce(
                            (acc, curr) => {
                              const category = curr.category;
                              const amount = parseFloat(curr.amount || 0);

                              if (!category) return acc; // Skip invalid categories

                              acc[category] = (acc[category] || 0) + amount;
                              return acc;
                            },
                            {}
                          )
                        ).map(([category, total], index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between py-1 ms-2"
                          >
                            <span>{category}</span>
                            <span>₹ {total.toFixed(2)}</span>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </div>

              <hr />

              <div className="row d-flex">
                {/* Income */}
                <div className="mb-4 col">
                  <h4 className="border-bottom pb-2">Income</h4>
                  <div className="d-flex justify-content-between py-1">
                    <span>Daily Income</span>
                    <strong>₹ {dailyAndMonthlyIncome?.dailyIncome}</strong>
                  </div>
                  <div className="d-flex justify-content-between py-1">
                    <span>Weekly Income</span>
                    <strong>₹ {dailyAndMonthlyIncome?.weeklyIncome}</strong>
                  </div>
                  <div className="d-flex justify-content-between py-1">
                    <span>Monthly Income</span>
                    <strong>₹ {dailyAndMonthlyIncome?.monthlyIncome}</strong>
                  </div>
                  <div className="d-flex justify-content-between py-1">
                    <span>Yearly Income</span>
                    <strong>₹ {dailyAndMonthlyIncome?.yearlyIncome}</strong>
                  </div>
                </div>

                {/* Profit Section */}
                <div className="mb-4 col">
                  <h4 className="border-bottom pb-2">Profit</h4>
                  <div
                    className={`d-flex justify-content-between py-1 ${
                      dailyProfit >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    <span>Daily Profit</span>
                    <strong>₹ {dailyProfit}</strong>
                  </div>
                  <div
                    className={`d-flex justify-content-between py-1 ${
                      weeklyProfit >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    <span>Weekly Profit</span>
                    <strong>₹ {weeklyProfit}</strong>
                  </div>
                  <div
                    className={`d-flex justify-content-between py-1 ${
                      monthlyProfit >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    <span>Monthly Profit</span>
                    <strong>₹ {monthlyProfit}</strong>
                  </div>
                  <div
                    className={`d-flex justify-content-between py-1 ${
                      yearlyProfit >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    <span>Yearly Profit</span>
                    <strong>₹ {yearlyProfit}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default FinancialDashboard;
